export enum EnableC3C5WorkflowStepsEnum {
    AdditionalChargeDialog,
    SelectDrugActivity,
    CustomizeNdcList
}